import React, { useState } from 'react';
import PropTypes from 'prop-types';

import PopupV2 from '../../../../Popup/PopupV2';
import { SOCIAL_HANDLE_MAX_LENGTH, SOCIAL_PLATFORMS } from '../constants';
import styles from '../../collegeProspectTab.scss';

const TESTID_PREFIX = 'modal.social-media';

const SocialMediaModal = ({ currentHandles, onClose, onSave }) => {
    const [handles, setHandles] = useState(() => Object.fromEntries(
        SOCIAL_PLATFORMS.map((platform) => [platform.key, currentHandles?.[platform.key] || '']),
    ));
    const [isSaving, setIsSaving] = useState(false);

    const handleChange = (key, value) => {
        setHandles((prev) => ({ ...prev, [key]: value }));
    };

    const handleSave = async () => {
        setIsSaving(true);
        const payload = Object.fromEntries(
            SOCIAL_PLATFORMS.map((platform) => [platform.key, handles[platform.key].trim() || null]),
        );
        await onSave(payload);
        setIsSaving(false);
    };

    return (
        <PopupV2
            onCloseClick={onClose}
            config={{
                size: 'medium',
                customHeader: () => null,
            }}
        >
            <div
                className={styles.socialMediaModal}
                data-testid={`${TESTID_PREFIX}.container`}
            >
                <div
                    className={styles.modalTitle}
                    data-testid={`${TESTID_PREFIX}.title`}
                >
                    Social
                </div>
                <p
                    className={styles.modalSubtitle}
                    data-testid={`${TESTID_PREFIX}.subtitle`}
                >
                    Add your handles so college coaches can find you.
                </p>

                <div
                    className={styles.socialFields}
                    data-testid={`${TESTID_PREFIX}.fields`}
                >
                    {SOCIAL_PLATFORMS.map((platform) => (
                        <div key={platform.key} className={styles.socialField}>
                            <label
                                className={styles.socialFieldLabel}
                                htmlFor={`social-handle-${platform.key}`}
                                data-testid={`${TESTID_PREFIX}.field-${platform.key}.label`}
                            >
                                {platform.label}
                            </label>
                            <input
                                id={`social-handle-${platform.key}`}
                                type="text"
                                className={`form-control ${styles.socialFieldInput}`}
                                value={handles[platform.key]}
                                maxLength={SOCIAL_HANDLE_MAX_LENGTH}
                                placeholder={`Add ${platform.label} handle`}
                                onChange={(event) => handleChange(platform.key, event.target.value)}
                                data-testid={`${TESTID_PREFIX}.field-${platform.key}.input`}
                            />
                        </div>
                    ))}
                </div>

                <div
                    className={styles.modalActions}
                    data-testid={`${TESTID_PREFIX}.actions`}
                >
                    <button
                        type="button"
                        className="btn btn-default btn-sm"
                        onClick={onClose}
                        data-testid={`${TESTID_PREFIX}.cancel-btn`}
                    >
                        CANCEL
                    </button>
                    <button
                        type="button"
                        className="btn btn-primary btn-sm"
                        onClick={handleSave}
                        disabled={isSaving}
                        data-testid={`${TESTID_PREFIX}.save-btn`}
                    >
                        SAVE
                    </button>
                </div>
            </div>
        </PopupV2>
    );
};

SocialMediaModal.propTypes = {
    currentHandles: PropTypes.shape({
        instagram: PropTypes.string,
        tiktok: PropTypes.string,
        facebook: PropTypes.string,
        x: PropTypes.string,
        youtube: PropTypes.string,
    }),
    onClose: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
};

SocialMediaModal.defaultProps = {
    currentHandles: null,
};

export default SocialMediaModal;
